angular.module('SpidApp')

.controller('StockFlowsController', [
                  '$scope'
                , 'StockFlowService'
                , 'StockService'
                , '$stateParams'
                , 'Stock'
                , 'StockFlow'
                , 'MonthStockChartGenerator'
                , 'YearStockChartGenerator'
                , '$timeout'
    , function (   $scope
                ,  StockFlowService
                ,  StockService
                ,  $stateParams
                ,  Stock
                ,  StockFlow
                ,  MonthStockChartGenerator
                ,  YearStockChartGenerator
                ,  $timeout) {
                	
    if (!$stateParams.agencyId || !$stateParams.stockId) {
        throw "StockFlowsController() - You didn't provide an agencyId and stockId"    
    }
    
    var agencyId = $stateParams.agencyId
    var stockId  = $stateParams.stockId
    
    StockService.findByAgencyIdAndStockId(agencyId, stockId).then(function (stock) {
        $scope.stock = stock
    })
    
    StockFlowService.allByAgencyIdAndStockIdAndMonth(agencyId, stockId, new Date().toISOString()).then(function (stockflows) {
        stockflows = _.sortBy(stockflows, function (stockflow) {
            return stockflow.updated_at
        }).reverse()
    
        $scope.currentMonthChart = new MonthStockChartGenerator(stockflows).get()
    });
        
    StockFlowService.allByAgencyIdAndStockIdAndYear(agencyId, stockId, new Date().toISOString()).then(function (stockflows) {
        stockflows = _.sortBy(stockflows, function (stockflow) {
            return stockflow.updated_at
        }).reverse()
    
        $scope.currentYearChart = new YearStockChartGenerator(stockflows).get()
    });
    
    $scope.printProductFlow = function() {
		$scope.dateNow = moment(new Date()).format('LLL');
		
		$timeout(function() {
    		window.print();
    	}, 50);
	}
}])
